<div [matTooltip]="placeholder.label | translate" matTooltipPosition="right" style="width:100%">
    <mat-form-field class="se-form-field se-from-to-form-field" appearance="outline">
        <mat-label>{{placeholder.from | translate}}</mat-label>
        <input matInput
               id="pickerFrom"
               class="se-form-field-input"
               [matDatepicker]="fromDate"
               (dateInput)="onDateInput($event, 'from')"
               (dateChange)="onFromToChange($event)"
               (keydown.enter)="onSearchRequired($event)"
               (keydown.space)="onSpaceBar($event)"
               [(ngModel)]="fromToModel.from"
               [placeholder]="placeholder.from | translate"
               se-autofocus [autofocus]="autofocus"
               [errorStateMatcher]="fromPickerMatcher"
               [disabled]="disabled"
               [min]="minFromDate"
               [max]="maxFromDate" />
        <mat-hint class="se-from-to-hint" *ngIf="!fromPickerMatcher.fromAfterTo">{{getDateFormat()}}</mat-hint>
        <mat-datepicker-toggle class="se-button-no-ripple se-mat-datepicker-toggle" tabindex="-1" [for]="fromDate" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #fromDate type="date"></mat-datepicker>
        <mat-error *ngIf="fromPickerMatcher.fromAfterTo">{{'InvalidDate' | translate}}</mat-error>
    </mat-form-field>

    <button mat-icon-button
            tabIndex="-1"
            class="se-from-to-button se-button-no-ripple"
            type="button"
            [disabled]="disabled"
            (click)="resetDateFrom($event)">
        <mat-icon>clear</mat-icon>
    </button>

    <mat-form-field class="se-form-field se-from-to-form-field" appearance="outline">
        <mat-label>{{placeholder.to | translate}}</mat-label>
        <input matInput
               id="pickerTo"
               class="se-form-field-input"
               [matDatepicker]="toDate"
               (dateInput)="onDateInput($event, 'to')"
               (dateChange)="onFromToChange($event)"
               (keydown.enter)="onSearchRequired($event)"
               (keydown.space)="onSpaceBar($event)"
               [(ngModel)]="fromToModel.to"
               [placeholder]="placeholder.to | translate"
               [errorStateMatcher]="toPickerMatcher"
               [disabled]="disabled"
               [min]="minFromDate"
               [max]="maxToDate" />
        <mat-hint class="se-from-to-hint">{{getDateFormat()}}</mat-hint>
        <mat-datepicker-toggle class="se-button-no-ripple se-mat-datepicker-toggle" tabindex="-1" [for]="toDate" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #toDate type="date"></mat-datepicker>
        <mat-error *ngIf="toPickerMatcher.fromAfterTo">{{'InvalidDate' | translate}}</mat-error>
    </mat-form-field>
    <button mat-icon-button
            tabIndex="-1"
            class="se-from-to-button se-button-no-ripple"
            type="button"
            [disabled]="disabled"
            (click)="resetDateTo($event)">
        <mat-icon>clear</mat-icon>
    </button>
    <button mat-icon-button
            type="button"
            tabIndex="-1"
            class="se-from-to-button  se-from-to-predefined-date-button se-button-no-ripple"
            [disabled]="disabled"
            [matMenuTriggerFor]="fromToMenu">
        <mat-icon>play_arrow</mat-icon>
    </button>
</div>
<mat-menu #fromToMenu="matMenu" yPosition="below" xPosition="after">
    <div *ngFor="let interval of predefiniteIntervals">
        <button mat-menu-item class="se-from-to-button se-menu-button"
                (click)="setPredefiniteInterval(interval)">
            <span>{{getLabelForInterval(interval)
            }}</span>
            </button>
</div>
</mat-menu>
